import { IonButton } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { dataTransferService } from "../../../services/dataTransferService";
import { utilService } from "../../../services/utilService";
import { setPatientAcceptanceService } from "../ProviderAlert/ProviderAlert.service";
import "./EMSPatientAlertList.scss";

interface ContainerProps {
  patientInputParams: any;
  updateList: any;
  isFromRejectStatus?: any;
}
const EMSPatientAlertList: React.FC<ContainerProps> = (props: any) => {
  const [userName, setUserName] = useState<string>("");
  const [userPassword, setUserPassword] = useState<string>("");
  const [isFormValid, setFormStatus] = useState(false);

  const isFirstRender = useRef(true);

  useEffect(() => {
    setFormStatus(formValidation());
  }, [userName, userPassword]);

  useEffect(() => {
    if (
      !isFirstRender.current &&
      props.patientInputParams.alert_status === "SENT"
    ) {
      let params = setProviderSeen();
      providerDataSeen(params);
    } else {
      isFirstRender.current = false;
    }
  }, [props.patientInputParams]);

  const formValidation = () => {
    return userName && userPassword ? true : false;
  };

  const setProviderSeen = () => {
    return {
      alert_id: props.patientInputParams.id,
      user_guid: utilService.getLoggedUserGuid(),
      response_type: "seen",
      reg_code: utilService.getNetwork(),
    };
  };

  async function providerDataSeen(params: any) {
    const resp: any = await setPatientAcceptanceService.providerAcceptData(
      params
    );
    if (resp.isSuccess) {
      props.updateList(props.patientInputParams.id);
      dataTransferService.caseHistoryUpdatedAction(true);
    } else {
      console.log("error");
    }
  }

  const emtAccept = () => {
    let params = setEMTAccept();
    providerDataAccept(params);
  };

  const setEMTAccept = () => {
    return {
      alert_id: props.patientInputParams.id,
      user_guid: utilService.getLoggedUserGuid(),
      response_type: "accepted",
      reg_code: utilService.getNetwork(),
    };
  };

  async function providerDataAccept(params: any) {
    const resp: any = await setPatientAcceptanceService.providerAcceptData(
      params
    );
    if (resp.isSuccess) {
      props.updateList(props.patientInputParams.id);
      dataTransferService.caseHistoryUpdatedAction(true);
    } else {
      console.log("error");
    }
  }

  return (
    <>
      <div className="ems-main-section">
        <div className="ems-main-container">
          <div className="ems-alert-label">
            <span className="label-ems">Assigned On: </span>
            <span className="ems-alert-details">
              {props.patientInputParams && props.patientInputParams.assigned_on
                ? props.patientInputParams.assigned_on
                : ""}
            </span>
          </div>
          <div className="ems-alert-label">
            <span className="label-ems">Assigned By: </span>
            <span className="ems-alert-details">
              {props.patientInputParams && props.patientInputParams.assigned_by
                ? props.patientInputParams.assigned_by.name
                : ""}
            </span>
          </div>
          <div className="ems-alert-label">
            <span className="label-ems">Case Type: </span>
            <span className="ems-alert-details">
              {props.patientInputParams &&
              props.patientInputParams.patient_case_types.length
                ? props.patientInputParams.patient_case_types[0]
                : "-Not selected-"}
              {props.patientInputParams &&
              props.patientInputParams.patient_case_types.length >= 2
                ? ` ( ${props.patientInputParams.patient_case_types.length} )`
                : ""}
            </span>
          </div>

          <div className="alert-button-container">
            <div className="send-button-div">
              <IonButton
                className="submit-btn button primary-btn btn-curved ems-alert-button"
                onClick={() => {
                  emtAccept();
                }}
              >
                Ok
              </IonButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EMSPatientAlertList;
